/**
 * Do not edit directly
 * Generated on Fri May 12 2023 10:58:21 GMT+0000
 */

module.exports = {
  TONE_PRIMARY_DARK: 'tone-primary-dark',
  TONE_DARK: 'tone-dark',
  TONE_MID: 'tone-mid',
  TONE_LIGHT: 'tone-light',
  TONE_VERY_LIGHT: 'tone-very-light',
  MONO_PRIMARY_DARK: 'mono-primary-dark',
  MONO_DARK: 'mono-dark',
  MONO_MID: 'mono-mid',
  MONO_LIGHT: 'mono-light',
  MONO_VERY_LIGHT: 'mono-very-light',
  MONO_PRIMARY_LIGHT: 'mono-primary-light',
  MONO_WARM: 'mono-warm',
  BLUE_100: 'blue-100',
  BLUE_200: 'blue-200',
  BLUE_400: 'blue-400',
  BLUE_500: 'blue-500',
  BLUE_600: 'blue-600',
  GREEN_100: 'green-100',
  GREEN_200: 'green-200',
  GREEN_400: 'green-400',
  GREEN_500: 'green-500',
  GREEN_600: 'green-600',
  TEAL_100: 'teal-100',
  TEAL_200: 'teal-200',
  TEAL_400: 'teal-400',
  TEAL_500: 'teal-500',
  TEAL_600: 'teal-600',
  ORANGE_100: 'orange-100',
  ORANGE_200: 'orange-200',
  ORANGE_400: 'orange-400',
  ORANGE_500: 'orange-500',
  ORANGE_600: 'orange-600',
  PURPLE_100: 'purple-100',
  PURPLE_200: 'purple-200',
  PURPLE_400: 'purple-400',
  PURPLE_500: 'purple-500',
  PURPLE_600: 'purple-600',
  RED_100: 'red-100',
  RED_200: 'red-200',
  RED_400: 'red-400',
  RED_500: 'red-500',
  RED_600: 'red-600',
  PINK_100: 'pink-100',
  PINK_200: 'pink-200',
  PINK_400: 'pink-400',
  PINK_500: 'pink-500',
  PINK_600: 'pink-600',
  YELLOW_100: 'yellow-100',
  YELLOW_200: 'yellow-200',
  YELLOW_400: 'yellow-400',
  YELLOW_500: 'yellow-500',
  BRAND_PRIMARY: 'brand-primary',
  LIGHTBOX_PRIMARY: 'lightbox-primary',
};
